import { Modal, ProgressBar, Button } from "react-bootstrap";
import { GameDataItem } from "../models/GameData";
import { Skills, xpToLevel, xpFromLevel } from "../models/Skills";
import { SKILLS } from "./SkillTable";

export interface SkillDetailsModalProps {
    id: string | keyof Skills;
    games: GameDataItem[];
    xp: number;
    rank: string;
    onHide: () => void;
}

export const SkillDetailsModal = ({ id, games, xp, rank, onHide }: SkillDetailsModalProps): React.ReactElement => {
    const level = xpToLevel(xp);
    const xpForNextLevel = xpFromLevel(level + 1);

    return (
        <Modal show centered size='lg' onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{SKILLS[id].icon} {SKILLS[id].name} - Level {level} {rank}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{xp} xp / {xpForNextLevel} xp</p>
                <ProgressBar min={xpFromLevel(level)} now={xp} max={xpForNextLevel} />
                <br />
                <p><em>{SKILLS[id].description}</em></p>
                <ul>
                    {games.map((game) => <li key={game.id}>{game.name}</li>)}
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
